import Badge from 'components/custom/Badge'

const SoulboundBadge = () => {
  return (
    <Badge
      badgeCss={{ backgroundColor: '#302017', color: '#FFD700', maxWidth: 137 }}
      badgeChildren={
        <>
          <img src="/icons/lock.svg" alt="lock icon" />
          Soulbound
        </>
      }
    />
  )
}

export default SoulboundBadge